/** La identidad de la agencia, tal como la devuelve `GET /empresa`. */

export type Empresa = {
  id: number
  nombre: string
  razon_social: string | null
  rif: string | null
  direccion: string | null
  pais_telefono: string | null
  telefono: string | null
  email: string | null
  sitio_web: string | null
  tiene_logo: boolean
  tiene_logo_oscuro: boolean
  etiqueta_sistema: string | null
  representante_legal: string | null
  documento_representante: string | null
  registro_mercantil: string | null
  ivss: string | null
  faov: string | null
  inces: string | null
  nil: string | null
  vision: string | null
  mision: string | null
  valores: string[]
  codigo_prefijo: string
}

export type ModoLogo = "claro" | "oscuro"

/**
 * La URL del logo.
 *
 * ⚠ **Lleva `v` con la marca de tiempo del último guardado.** Sin ella, el navegador
 * sirve el logo viejo de su caché después de cambiarlo y parece que la subida no
 * funcionó — es exactamente lo que resuelve el `?t=<?= time() ?>` del 2.0.
 */
export function urlLogo(modo: ModoLogo, version: number): string {
  return `/api/v1/empresa/logo/${modo}?v=${version}`
}

/** Cómo se muestra el nombre: la razón social manda, el comercial es el respaldo. */
export function comoSeLlama(empresa: Empresa): string {
  return empresa.razon_social?.trim() || empresa.nombre
}
